document.addEventListener('DOMContentLoaded', function () {
  let e;
  const t = window.matchMedia('(max-width: 1050px)');

  const n = () => {
    const swiperEl = document.querySelector('.collection-grid--gird-head');
    if (!swiperEl) return; // Exit if element not found

    e = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      mousewheel: true,
      keyboard: true,
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        750: { slidesPerView: 2, spaceBetween: 20 },
      },
    });

    document.querySelectorAll('.collection-grid--item[role="group"]').forEach((el) => {
      el.removeAttribute('role');
    });
  };

  const i = () => {
    t.matches ? e || n() : e && (e.destroy(true, true), (e = undefined));
  };

  t.addEventListener('change', i);
  i();
});
